<template>
  <form data-vv-scope="otp-form" @submit.prevent="activateSign">
    <div class="container-pdf" v-if="signConfiguration.urlResponsavilidad">
      <pdf
        class="m-auto"
        v-for="(p, index) in numPages"
        :key="`${p}-${index}`"
        :page="p"
        :src="signConfiguration.urlResponsavilidad"
      />
    </div>
    <label>Código OTP</label>
    <b-form-input
      v-model="otp"
      id="otp_input"
      name="otp_input"
      data-vv-as="otp"
      v-validate="'required|digits:6'"
      :state="!this.errors.has('otp-form.otp_input')"
      placeholder="Ingrese los 6 dígitos de Google Authenticator"
    />
    <FormError
      attributeName="otp-form.otp_input"
      :errorsForm="errors"
    />
    <div class="text-center mt-4">
      <b-button
        :title="otp ? 'Activar' : 'Ingrese 6 dígitos'"
        :disabled="loading || !otp"
        variant="primary"
        @click="activateSign">
        {{getBtnText()}}
      </b-button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import pdf from 'vue-pdf-signature';

import FormError from '@/febos/global/documentManagement/components/FormError';
import { configureSimpleAndEsign7Sign } from '@/febos/servicios/api/usuarios.api';

export default {
  name: 'ActivateEnrollment',
  components: {
    FormError,
    pdf,
  },
  props: ['user', 'signConfiguration'],
  data() {
    return {
      otp: null,
      loading: false,
      numPages: [],
      selectedFile: null
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'hasPermission'
    ]),
    isSuperAdmin() {
      return this.hasPermission('FEB99');
    }
  },
  methods: {
    getBtnText() {
      if (this.isSuperAdmin) {
        return 'Activar para enrolamiento';
      }
      return 'Firmar responsabilidad y activar para enrolamiento';
    },
    async activateSign() {
      this.loading = true;
      const formCheck = await this.$validator.validateAll('otp-form');
      if (formCheck) {
        let parametros = {};
        if (this.isSuperAdmin) {
          parametros = {
            accion: 'ACTIVAR_S'
          };
        } else {
          parametros = {
            accion: 'ACTIVAR',
            urlResponsavilidad: this.signConfiguration.urlResponsavilidad
          };
        }
        const data = {
          codigo: this.otp,
          idUsuarioFirma: this.user.id,
          parametros,
          proveedor: 'esign7',
          tipoFirma: 'firmaAvanzada'
        };
        try {
          await configureSimpleAndEsign7Sign(data);
          this.$emit('signed');
          this.$bvToast.toast(
            'Identificador de firma grabado exitosamente',
            {
              title: 'Firma Avanzada',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              noAutoHide: true
            }
          );
        } catch {
          this.loading = false;
        }
      }
      this.loading = false;
    },
  },
  created() {
    if (this.signConfiguration.urlResponsavilidad) {
      this.selectedFile = pdf.createLoadingTask(this.signConfiguration.urlResponsavilidad);
      this.selectedFile.promise.then((pdfUrl) => {
        this.numPages = pdfUrl.numPages;
      });
    }
  }
};
</script>

<style scoped>
.container-pdf {
  height: 500px;
  overflow-y: auto;
  width: 100%;
}
</style>
